import React, { useEffect, useRef } from "react";
import "./layout.css";

export default function Display() {
  const displayTextRef = useRef(null);
  const displayDetails = JSON.parse(
    process.env.REACT_APP_DISPLAY_DETAILS ?? "{}"
  );

  useEffect(() => {
    if (displayTextRef.current) {
      displayTextRef.current.innerHTML = displayDetails.text ?? "";
    }
  }, [displayDetails.text]);

  return (
    <>
      {displayDetails &&
        displayDetails.displayAt &&
        displayDetails.displayAt.includes(window.location.pathname) && (
          <div className="amber-bg left-align-text">
            <h4 ref={displayTextRef} className="font-weight-normal">
              No Message To Display
            </h4>
          </div>
        )}
    </>
  );
}
